<div class="container">

<form autocomplete="off" [formGroup]="myForm" (ngSubmit)="submit()">
    <h1 class="pt-3 pr-3" mat-dialog-title>Cambiar Contraseña</h1>
    <hr>
    <mat-dialog-content>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group p-3">
                    <label>Contraseña Actual <span class="text-danger">*</span></label>
                    <div class="input-group">
                        <input [type]="hideCurrentPassword ? 'password' : 'text'" formControlName="currentPassword"
                            class="form-control rounded-0 shadow-background" placeholder="Ingrese su contraseña actual">
                        <div class="input-group-append">
                            <button type="button" class="btn btn-outline-secondary"
                                (click)="hideCurrentPassword = !hideCurrentPassword">
                                <i [class]="hideCurrentPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
                            </button>
                        </div>
                    </div>
                    <span class="text-danger" *ngIf="isValiField('currentPassword')">
                        {{ getFieldError('currentPassword') }}
                    </span>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="form-group p-3">
                    <label>Nueva Contraseña <span class="text-danger">*</span></label>
                    <div class="input-group">
                        <input [type]="hideNewPassword ? 'password' : 'text'" formControlName="newPassword"
                            class="form-control rounded-0 shadow-background" placeholder="Ingrese su nueva contraseña">
                        <div class="input-group-append">
                            <button type="button" class="btn btn-outline-secondary"
                                (click)="hideNewPassword = !hideNewPassword">
                                <i [class]="hideNewPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
                            </button>
                        </div>
                    </div>
                    <span class="text-danger" *ngIf="isValiField('newPassword')">
                        {{ getFieldError('newPassword') }}
                    </span>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">


                <div class="form-group p-3">
                    <label>Confirmar Nueva Contraseña <span class="text-danger">*</span></label>
                    <div class="input-group">
                        <input [type]="hideConfirmPassword ? 'password' : 'text'" formControlName="confirmPassword"
                            class="form-control rounded-0 shadow-background" placeholder="Confirme su nueva contraseña">
                        <div class="input-group-append">
                            <button type="button" class="btn btn-outline-secondary"
                                (click)="hideConfirmPassword = !hideConfirmPassword">
                                <i [class]="hideConfirmPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
                            </button>
                        </div>
                    </div>
                    <span class="text-danger" *ngIf="isValiField('confirmPassword')">
                        {{ getFieldError('confirmPassword') }}
                    </span>
                </div>
            </div>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <div class="row">
            <div class="col-md-12 p-3">
                <button type="button" class="btn btn-secondary" (click)="cancel()">
                    <i class="fas fa-times"></i> Cancelar
                </button>
                <button type="submit" class="btn btn-primary ml-2">
                    <i class="fas fa-save"></i> Guardar
                </button>
            </div>
        </div>
    </mat-dialog-actions>
</form>
</div>
